/* eslint-disable tailwindcss/classnames-order */
import { useCallback, useContext, useEffect, useRef, useState } from "react"
import { data } from "../app"
import { BookNavModalContext } from "./Contexts"

const BookHeader = () => {
  const { setIsOpen } = useContext(BookNavModalContext)
  const chapterToNumber = useCallback(
    (value: string) => (value ? value.replace(/#?ch-/, "") : "1"),
    []
  )
  const [chapterNumber, setChapterNumber] = useState<string>(chapterToNumber(window.location.hash))

  // @TODO: consider switching link updates with `pushState`
  useEffect(() => {
    const hashChange = () => {
      const hash = window.location.hash
      const newChapter = chapterToNumber(hash)
      // reset scrollRef so observer doesn't think this is scrolling up
      scrollRef.current = 0
      setChapterNumber(newChapter)
    }

    window.addEventListener("hashchange", hashChange, false)

    return () => {
      window.removeEventListener("hashchange", hashChange)
    }
  }, [chapterToNumber])

  const scrollRef = useRef(0)
  const bookTitle = data.title
  // @see https://reacthustle.com/blog/how-to-track-scroll-direction-inside-intersection-observer-in-react
  useEffect(() => {
    const chapters = Array.from(document.querySelectorAll(".Chapter-number, .Psalm-Chapter-Title"))
    const ids = chapters.map(e => e.id)
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const id = entry.target.getAttribute("id") ?? ""

          if (entry.isIntersecting) {
            setChapterNumber(chapterToNumber(id))
            scrollRef.current = window.scrollY
            return
          }
          const diff = scrollRef.current - window.scrollY
          const isScrollingUp = diff > 0
          const currentIndex = ids.indexOf(id)
          const prevEntry = ids[currentIndex - 1]
          if (isScrollingUp) {
            const id = prevEntry
            setChapterNumber(chapterToNumber(id))
          }
        })
      },
      {
        rootMargin: "0% 0% -77% 0%",
        threshold: 0.2,
      }
    )
    chapters.forEach(el => {
      observer.observe(el)
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <button
      className="whitespace-nowrap rounded-md px-2 py-1"
      onClick={() => {
        setIsOpen(true)
      }}
    >
      <div className="border-b-2 border-dotted border-white px-2 py-0 text-2xl text-white">
        {bookTitle} {chapterNumber}
      </div>
    </button>
  )
}

export default BookHeader
